module.exports = {"version":"3.2.0rc55"}


//////////////////
// WEBPACK FOOTER
// ./src/package.json
// module id = 1019
// module chunks = 0